<div class="modal-header">
    <h5 class="modal-title">Edit Profile</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
    <!-- Banner Section -->
    <div class="banner-container position-relative">
        <img [src]="BannerImageDisplayUrl"
             alt="Banner Image"
             class="img-fluid w-100 rounded">
        <button class="btn btn-light btn-sm position-absolute top-50 start-50 translate-middle banner-edit-btn"
                (click)="triggerFileUpload('banner')">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-camera" viewBox="0 0 16 16">
                <path d="M10.5 1a1 1 0 0 1 .8.4l.86 1.2H14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4.6a2 2 0 0 1 2-2h1.34l.86-1.2A1 1 0 0 1 4.5 1h6ZM3.25 4a.25.25 0 0 0-.25.25v7.5a.25.25 0 0 0 .25.25h9.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25H3.25ZM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" />
            </svg>
        </button>
    </div>

    <!-- Profile Image Section -->
    <div class="profile-image-container position-relative text-center mb-4">
        <img [src]="UserImageDisplayUrl"
             alt="Profile Image"
             class="profile-image circular-image rounded-circle">
        <button class="profile-image-btn btn btn-light btn-sm position-absolute profile-edit-btn"
                (click)="triggerFileUpload('profile')">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-camera" viewBox="0 0 16 16">
                <path d="M10.5 1a1 1 0 0 1 .8.4l.86 1.2H14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4.6a2 2 0 0 1 2-2h1.34l.86-1.2A1 1 0 0 1 4.5 1h6ZM3.25 4a.25.25 0 0 0-.25.25v7.5a.25.25 0 0 0 .25.25h9.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25H3.25ZM8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z" />
            </svg>
        </button>
    </div>

    <!-- Hidden File Input -->
    <input type="file" id="fileUpload" (change)="checkFileUpload($event)" accept="image/jpeg,image/png,image/gif" style="display: none;">

    <!-- Form Section -->
    <form [formGroup]="profileForm">
        <!-- Name Field -->
        <div class="form-group mb-4 position-relative input-container">
            <input type="text"
                   id="nameInput"
                   class="form-control styled-input"
                   formControlName="ProfileName"
                   maxlength="50"
                   (focus)="setActive('ProfileName')"
                   (blur)="removeActive('ProfileName')" />
            <label class="floating-label"
                   [class.active]="profileForm.get('ProfileName')?.value || activeField === 'ProfileName'"
                   for="nameInput">
                Name
            </label>
            <small class="character-count"
                   [class.hidden]="!profileForm.get('ProfileName')?.value && activeField !== 'ProfileName'">
                {{ profileForm.get('ProfileName')?.value?.length || 0 }}/50
            </small>
            <div *ngIf="profileForm.get('ProfileName')?.invalid && profileForm.get('ProfileName')?.touched" class="text-danger mt-1">
                Name can't be blank
            </div>
        </div>

        <!-- Bio Field -->
        <div class="form-group mb-4 position-relative input-container">
            <textarea id="bioInput"
                      class="form-control styled-input"
                      formControlName="ProfileBio"
                      maxlength="150"
                      rows="3"
                      (focus)="setActive('ProfileBio')"
                      (blur)="removeActive('ProfileBio')"></textarea>
            <label class="floating-label"
                   [class.active]="profileForm.get('ProfileBio')?.value || activeField === 'ProfileBio'"
                   for="bioInput">
                Bio
            </label>
            <small class="character-count"
                   [class.hidden]="!profileForm.get('ProfileBio')?.value && activeField !== 'ProfileBio'">
                {{ profileForm.get('ProfileBio')?.value?.length || 0 }}/150
            </small>
        </div>

        <!-- Location Field -->
        <div class="form-group mb-4 position-relative input-container">
            <input type="text"
                   id="locationInput"
                   class="form-control styled-input"
                   formControlName="Location"
                   maxlength="30"
                   (focus)="setActive('Location')"
                   (blur)="removeActive('Location')" />
            <label class="floating-label"
                   [class.active]="profileForm.get('Location')?.value || activeField === 'Location'"
                   for="locationInput">
                Location
            </label>
            <small class="character-count"
                   [class.hidden]="!profileForm.get('Location')?.value && activeField !== 'Location'">
                {{ profileForm.get('Location')?.value?.length || 0 }}/30
            </small>
        </div>

        <!-- Website Field -->
        <div class="form-group mb-4 position-relative input-container">
            <input type="text"
                   id="websiteInput"
                   class="form-control styled-input"
                   formControlName="URL"
                   maxlength="100"
                   (focus)="setActive('URL')"
                   (blur)="removeActive('URL')" />
            <label class="floating-label"
                   [class.active]="profileForm.get('URL')?.value || activeField === 'URL'"
                   for="websiteInput">
                Website
            </label>
            <small class="character-count"
                   [class.hidden]="!profileForm.get('URL')?.value && activeField !== 'URL'">
                {{ profileForm.get('URL')?.value?.length || 0 }}/100
            </small>
        </div>

        <!-- Birthday Field -->
        <div class="form-group mb-4 position-relative input-container">
            <input type="date"
                   id="birthdayInput"
                   class="form-control styled-input"
                   formControlName="BirthDate"
                   (focus)="setActive('BirthDate')"
                   (blur)="removeActive('BirthDate')" />
            <label class="floating-label"
                   [class.active]="profileForm.get('BirthDate')?.value || activeField === 'BirthDate'"
                   for="birthdayInput">
                Birthdate
            </label>
        </div>

    </form>



</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveProfile()">Save</button>
</div>
